import { z } from 'zod';

/**
 * Webapp reset password schema. The form posts {password,
 * confirmPassword, token, email}; token + email are not user-editable
 * (they come from the magic link) but we still require them at the
 * action layer.
 */
export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(1, 'Password is required')
      .min(8, 'Password must be at least 8 characters')
      .regex(/(?=.*[a-z])(?=.*[A-Z])/, {
        message: 'Password must contain uppercase and lowercase letters',
      })
      .regex(/\d/, {
        message: 'Password must contain at least one number',
      })
      .regex(/[^a-zA-Z\d]/, {
        message: 'Password must contain at least one special character',
      }),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
    token: z.string().min(1, 'Invalid reset token'),
    email: z.string().email('Invalid email').optional().or(z.literal('')),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
